import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift } from 'lucide-react';
import { bonuses } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-white border-y border-slate-200" data-id="element-19" data-mp="22fmv4tjdi00j">
      <div className="max-w-5xl mx-auto" data-id="element-20" data-mp="22divwowf5p6l">
        <div className="text-center mb-16" data-id="element-21" data-mp="1ydi7qcjipzmc">
          <p className="text-[#84651F] font-bold tracking-widest uppercase mb-2" data-id="element-22" data-mp="1yet9k6tekxat">
            Included With Your Purchase at No Additional Cost
          </p>
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-[#1F4D3A]" data-id="element-23" data-mp="15pw10vezuev9">
            <span className="text-[#9C7726]" data-id="element-24" data-mp="1jgitw6y2pajf">5</span> EXCLUSIVE BARTENDING{' '}
            <span className="text-[#9C7726]" data-id="element-25" data-mp="1jilnt22cjntf">INSTRUCTOR BONUSES</span>
          </h2>
          <p className="text-lg text-slate-700/80 max-w-3xl mx-auto mt-5" data-id="element-26" data-mp="1eny0v7mzr1gy">
            The six main volumes give you visual training material for every core bartending topic. And the
            five bonuses add practical tools to help you hand out clear cocktail specs, script your service
            classes, run quick bar station drills, train jigger accuracy and speed, and assess students with
            clear rubrics and certificates.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-27" data-mp="2jj7f47mo4y2u">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white border border-slate-200 rounded-2xl p-8 shadow-sm shadow-[#1F4D3A]/5 relative flex flex-col ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-28" data-mp="2ofo5z9l95qjm" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-[#1F4D3A] text-white px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm" data-id="element-29" data-mp="3c5s81cisli8i">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-[#F5EBDD] border border-[#C9A24B] rounded-full flex items-center justify-center text-[#9C7726] mb-4" data-id="element-30" data-mp="1h2cdhmupfgsd">
                <Gift size={24} data-id="element-31" data-mp="1c6oksxh0k5i4" />
              </div>
              <h3 className="text-xl font-bold tracking-tight mb-2 pr-28 text-[#1F4D3A]" data-id="element-32" data-mp="1q3248c53ygz8">{bonus.title}</h3>
              <p className="text-[#84651F] text-sm font-semibold mb-4 border-l-4 border-[#C9A24B] pl-4" data-id="element-33" data-mp="1m3t8x2uf6b1k">
                {bonus.subtitle}
              </p>
              {bonus.referenceValueCents !== undefined && <p className="flex flex-wrap items-baseline gap-x-2 text-sm mb-4" data-id="element-34" data-mp="tfnnsezgek17">
                  <span className="text-slate-500" data-id="element-35" data-mp="1760u6cwp5qof">Reference value:</span>
                  <span className="text-slate-500 line-through" data-id="element-36" data-mp="12e92fz1t1ewp">
                    {formatUsd(bonus.referenceValueCents)}
                  </span>
                  <span className="font-extrabold text-[#84651F] uppercase tracking-wide" data-id="element-37" data-mp="emtvtu2zwbfn">
                    Included free
                  </span>
                </p>}
              {bonus.intro && <p className="text-slate-700 text-sm mb-4 leading-relaxed" data-id="element-38" data-mp="5a4kp5j8tmkw">{bonus.intro}</p>}

              {bonus.bullets && <>
                  <p className="text-[#1F4D3A] font-semibold text-sm mb-3" data-id="element-39" data-mp="3ms5vw6sjdbh5">{bonus.bulletsIntro}</p>
                  <ul className={`mb-6 ${bonus.bullets.length > 8 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-2' : 'space-y-2'} ${index === 4 ? 'md:grid-cols-4' : ''}`} data-id="element-40" data-mp="3rq7jn50wpyyy">
                    {bonus.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-41" data-mp="9bgfrqkvz00h">
                        <CheckCircle2 size={16} className="text-[#9C7726] shrink-0 mt-0.5" data-id="element-42" data-mp="e9rlbp45eocw" />
                        <span className="text-slate-700 text-sm" data-id="element-43" data-mp="2u0w0q4xfbui7">{bullet}</span>
                      </li>)}
                  </ul>
                </>}

              {bonus.detailedBullets && <>
                  <p className="text-[#1F4D3A] font-semibold text-sm mb-3" data-id="element-44" data-mp="3f9zperrcclup">{bonus.bulletsIntro}</p>
                  <ul className="mb-6 space-y-3" data-id="element-45" data-mp="3afloyaxtnoj6">
                    {bonus.detailedBullets.map(item => <li key={item.title} className="flex items-start gap-3" data-id="element-46" data-mp="30jacnky8eyoq">
                        <CheckCircle2 size={16} className="text-[#9C7726] shrink-0 mt-0.5" data-id="element-47" data-mp="30h5z0baj6lb9" />
                        <div data-id="element-48" data-mp="1zk62y4zuq56">
                          <span className="block text-[#1F4D3A] font-bold text-sm" data-id="element-49" data-mp="3t87gij1p4sxy">{item.title}</span>
                          <span className="block text-slate-700 text-sm" data-id="element-50" data-mp="3o8l3oaps5epo">{item.detail}</span>
                        </div>
                      </li>)}
                  </ul>
                </>}

              {bonus.secondaryBullets && <>
                  <p className="text-[#1F4D3A] font-semibold text-sm mb-3" data-id="element-51" data-mp="27ul97f9peh9t">
                    {bonus.secondaryBulletsIntro}
                  </p>
                  <ul className="mb-6 grid sm:grid-cols-2 gap-x-4 gap-y-2" data-id="element-52" data-mp="ndvldeicke71">
                    {bonus.secondaryBullets.map(bullet => <li key={bullet} className="text-[#1F4D3A] font-semibold text-sm bg-[#F5EBDD] border border-[#E7D4AE] rounded-lg px-3 py-2" data-id="element-53" data-mp="xaqfll7l7sfi">
                        {bullet}
                      </li>)}
                  </ul>
                  {bonus.secondaryNote && <p className="-mt-3 mb-6 text-slate-700 text-sm italic" data-id="element-54" data-mp="1b0k6sa6keose">{bonus.secondaryNote}</p>}
                </>}

              <div className="mt-auto space-y-3" data-id="element-55" data-mp="1l0uh9n17ti3v">
                {bonus.system && <div data-id="element-56" data-mp="3hsumurv4kqgg">
                    <p className="text-[#1F4D3A] font-semibold text-sm mb-2" data-id="element-57" data-mp="3hte3m591h8sw">{bonus.systemLabel}</p>
                    <p className="text-[#1F4D3A] font-bold text-xs sm:text-sm tracking-wide bg-[#F5EBDD] border-l-4 border-[#C9A24B] rounded-lg px-3 py-2" data-id="element-58" data-mp="3msqsswnduryn">
                      {bonus.system}
                    </p>
                  </div>}
                {bonus.result && <div className="bg-[#FBF6EF] border border-[#E7D4AE] border-l-4 border-l-[#1F4D3A] rounded-xl p-4" data-id="element-59" data-mp="3opfpgnswgqvl">
                    <span className="text-[#1F4D3A] font-bold block mb-1" data-id="element-60" data-mp="3jpb9cyvwly5w">RESULT</span>
                    <p className="text-slate-700 text-sm" data-id="element-61" data-mp="1jeoxoswxobq">{bonus.result}</p>
                  </div>}
                {bonus.closing && <div className="pt-4 border-t border-slate-200" data-id="element-62" data-mp="3tmftyua3plkl">
                    {bonus.closing.map((line, lineIndex) => <p key={line} className={lineIndex === 0 ? 'text-[#1F4D3A] font-extrabold text-base tracking-wide' : 'text-[#1F4D3A] font-semibold text-sm italic'} data-id="element-63" data-mp="6awpibr0xmw6" data-mpi={lineIndex}>
                        {line}
                      </p>)}
                  </div>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}
function formatUsd(cents: number): string {
  return `$${(cents / 100).toFixed(2)} USD`;
}